import { render, staticRenderFns } from "./verlinkungen-bearbeiten-modal.vue?vue&type=template&id=173bec1b&scoped=true"
import script from "./verlinkungen-bearbeiten-modal.vue?vue&type=script&lang=js"
export * from "./verlinkungen-bearbeiten-modal.vue?vue&type=script&lang=js"
import style0 from "./verlinkungen-bearbeiten-modal.vue?vue&type=style&index=0&id=173bec1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173bec1b",
  null
  
)

export default component.exports